import { getAPIs } from "./APILinks";
import customAxios from "./AxiosInterceptors";


const currentHostname = window.location.hostname;
const currentPort = window.location.port;
export function getAPIActionJSON(
  type,
  data,
  onError = () => { },
  params = "",
  onSuccess = () => { },
  addparams = '',
  isLoading = true,
) {


  const api = getAPIs[type];
  let baseUrl = api.path + addparams
  if ((currentHostname === '127.0.0.1' || currentHostname === 'localhost') && currentPort === '5173') {
    baseUrl = "api" + api.path + addparams;
  }

  return (dispatch) => {
    isLoading && dispatch({ type: "api.loading" });
    customAxios({
      method: api.method,
      url: baseUrl,
      params: params,
      data: data,
    })
      .then(function (response) {
        isLoading && dispatch({ type: "api.success" });
        if (response.headers["x-api-key"]) {
          localStorage.setItem("x-api-key", response.headers["x-api-key"]);
        }
        if (response.status === 200 || response.status === 202) {
          dispatch({
            type: `${type}.reply`,
            data: response.data,
            headers: response.headers,
          });
        }
        if (response.status === 200 || response.status === 202 || response.status === 201) {
          onSuccess(response.data)
        }
      })
      .catch((e) => {
        console.log("api error", e)
        if (e.response.status === 401) {
          dispatch({ type: 'tokenExpired' })
        }
        onError(e.response.data)
        dispatch({ type: "api.success" });
      });
  };
}

export async function getStatelessAPI(
  type,
  data,
  headers,
  params = {},
  addparams = ''
) {
  const api = getAPIs[type];
  try {
    const res = await customAxios({
      method: api.method,
      url: api.path + addparams,
      params: params,
      data: data,
      headers: headers
    });
    const responseData = res.data;
    return responseData;
  } catch (error) {
    if (error) {
      // Error Handler
      console.log(error);
    }
  }
}